import { render, staticRenderFns } from "./IssueStockDetails.vue?vue&type=template&id=0b5c8084&scoped=true&"
import script from "./IssueStockDetails.vue?vue&type=script&lang=js&"
export * from "./IssueStockDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5c8084",
  null
  
)

export default component.exports